module.exports = __webpack_public_path__ + "static/diamond-desc-x2-a62d5bdf7a41a9ca231b4ae81f052205.webp";